import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import FloatLabelInput from "../../../components/FloatingLabel";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import { useTranslation } from "react-i18next";

const AddOnSumInsured = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [sum_insured, setSumInsured] = useState("");
	const { t } = useTranslation();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const selectedPlan = useGetCarPlan();
	const selectedAddOn = location.state?.addOn;

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>{t(`autoInsurance.addOnSumInsured.noAddOnSelected`)}</h3>
				<Button
					label={t(`autoInsurance.addOnSumInsured.goBack`)}
					onClick={() => navigate(-1)}
				/>
			</div>
		);
	}

	const handleInputChange = (e) => {
		e.preventDefault();

		const value = e.target.value;
		if (/^\d*$/.test(value)) {
			setSumInsured(value); // Set the value only if it's a valid number
		}
	};

	const handleReturnClick = (e) => {
		e.preventDefault();

		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		if (selectedPlan?.insurer_name) {
			localStorage.setItem(
				"M02_sum_insured",
				JSON.stringify({
					name: "WINDSCREEN",
					si: sum_insured,
					unit: "0",
				})
			);
		}

		navigate(
			policyId
				? `/get-quote/add-ons?policy_id=${policyId}`
				: `/get-quote/add-ons`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					sum_insured: sum_insured, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${t(`autoInsurance.addOnSumInsured.title`)} ${
					selectedAddOn.title
				}`}</h3>

				{/* Add-on Details */}
				<div className="add-on-details border-radius-10 w-100">
					<FloatLabelInput
						className="mb-2"
						label={t(
							`autoInsurance.addOnSumInsured.totalProtectionValue`
						)}
						value={sum_insured}
						onChange={(e) => handleInputChange(e)}
						placeholder=""
						type="text"
					/>
					{/* <span className="fw-bold color-heading">{`Minimum Amount: `}</span>
					<span className="fw-bold color-primary">{`RM 540.00`}</span> */}
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{t(
									`autoInsurance.addOnSumInsured.selectingAddOnsFor`
								)}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center py-2">
						{/* Total Price Section */}
						<div className="w-50">
							<span className="fs-xl fw-bold">{`RM ${sum_insured}`}</span>
						</div>
					</div>
					<Button
						label={t(`autoInsurance.addOnsOther.returnAddOns`)}
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnSumInsured;
